module.exports = __webpack_public_path__ + "static/lichen-f932b0f5ade36f3c046b01f15462b50e.png";